import React from 'react';

function Footer() {
  return (
          <footer className="footer">
            <p className="footer__copyright">&copy; 2021 Mesto</p>
          </footer>
  );
}

export default Footer;
